const LOAD_COMMODITY = 'load_commodity';
const SET_SELECTED_COMMODITY = 'set_selected_commodity';
const SHOW_DELETE_CONFIRM_DIALOG = 'show_delete_confirm_dialog';
const SHOW_ADD_EDIT_DIALOG = 'show_add_edit_dialog';
const EDIT_COMMODITY_DETAILS = 'edit_commodity_details';
const ADD_COMMODITY_DETAILS = 'add_commodity_details';
const SET_DELETE_COMMODITY = 'set_delete_commodity';

export const loadCommodity = (commodities) => ({
    type: loadCommodity.type,
    payload: commodities
})
loadCommodity.type = LOAD_COMMODITY;

export const setSelectedCommodity = (selectedCommodity) => ({
    type: setSelectedCommodity.type,
    payload: selectedCommodity
})
setSelectedCommodity.type = SET_SELECTED_COMMODITY;

export const showDeleteConfirmationDialog = (showDialog) => ({
    type: showDeleteConfirmationDialog.type,
    payload: showDialog
})
showDeleteConfirmationDialog.type = SHOW_DELETE_CONFIRM_DIALOG;

export const showAddEditDialog = (showDialog) => ({
    type: showAddEditDialog.type,
    payload: showDialog
})
showAddEditDialog.type = SHOW_ADD_EDIT_DIALOG;

export const editCommodityDetails = (isEditing) => ({
    type: editCommodityDetails.type,
    payload: isEditing
})
editCommodityDetails.type = EDIT_COMMODITY_DETAILS;

export const addCommodityDetails = (isAdding) => ({
    type: addCommodityDetails.type,
    payload: isAdding
})
addCommodityDetails.type = ADD_COMMODITY_DETAILS;

export const setDeletedCommodity = (selectedCommodity) => ({
    type: setDeletedCommodity.type,
    payload: selectedCommodity
})
setDeletedCommodity.type = SET_DELETE_COMMODITY;